import React from "react";

interface MainMenuProps {
  onCreateClick: () => void;
  onPlayClick: () => void;
}

export const MainMenu: React.FC<MainMenuProps> = ({
  onCreateClick,
  onPlayClick,
}) => {
  return (
    <div className="w-full h-full flex flex-col p-6 pb-3">
      <h1 className="font-raleway text-4xl font-extrabold text-center mb-6 text-white uppercase">
        Strands<span className="text-selected">.</span>
      </h1>
      <p className="text-white text-center mb-8">
        Create your own Strands puzzle or play one created by others!
      </p>

      <div className="mb-6 flex flex-col gap-6 items-center">
        <button
          onClick={onPlayClick}
          className="btn text-white bg-selected w-3/4 max-w-xs py-4 font-extrabold transition text-lg hover:shadow-lg uppercase"
        >
          Play
        </button>
        <button
          onClick={onCreateClick}
          className="btn text-black bg-white w-3/4 max-w-xs py-4 font-extrabold transition text-lg hover:shadow-lg uppercase"
        >
          Create
        </button>
      </div>

      <div className="mt-auto mb-8 pb-3 border-t border-white/30">
        <h2 className="font-raleway text-2xl font-semibold my-4 text-white">
          How to Play
        </h2>
        <p className="text-white mb-2">
          Find a word chain where adjacent letters must form valid words. Each
          puzzle has a theme that connects all the words. Select letters to form
          words and reveal the hidden theme!
        </p>
        <p className="text-white font-semibold">Example: "Fruits"</p>
        <div className="flex justify-center gap-1 mt-2">
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">A</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">P</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">P</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">L</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">E</div>
          <div className="w-10 h-10 bg-[var(--color-revealed)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">→</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">P</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">E</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">A</div>
          <div className="w-10 h-10 bg-[var(--color-letter-tile)] rounded-lg flex items-center justify-center font-cal text-lg font-semibold">R</div>
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
